export default __webpack_public_path__ + "static/0216-276256fa1d9ebf917442d63ff2fb6e9f.png";